import { normalizeMentionText } from '@/utils/atMention';

/** @deprecated Use resolveUserIntent; kept for tests and future NLP hints. */
export function isBulkUserImportMessage(raw: string): boolean {
  const text = normalizeMentionText(raw.trim());
  if (!text) return false;

  if (/group\s+of\s+users/i.test(text)) return true;
  if (/bulk\s+user/i.test(text)) return true;
  if (/(?:add|import|create)\s+(?:a\s+)?(?:group|multiple|several)\s+of\s+users/i.test(text)) return true;
  if (/(?:add|import)\s+users?\s+(?:from|via|using)\s+(?:csv|file|spreadsheet)/i.test(text)) return true;
  if (/users?.*(?:attach|attached|csv|\.csv)/i.test(text) && /(?:add|import|group|attach)/i.test(text)) return true;
  if (/attach(?:ed)?\s+(?:in\s+)?(?:the\s+)?file/i.test(text) && /users?/i.test(text)) return true;

  return false;
}
